import useAppDataInitialization from '../hooks/useAppDataInitialization';

/**
 * Global business data boot (products, company, sales lists, …).
 * Must only mount after AuthzReadyGate confirms UMS app access.
 */
const AppDataInitializer = (props) => {
    useAppDataInitialization(props);
    return null;
};

export default AppDataInitializer;
